//import { /*CRUDBasicDetailComponent_Template,*/ CRUDBasicDetailComponent } from '../crud-basic-detail/crud-basic-detail.component';
import { CRUDBasicDetailForChildComponent } from '../crud-basic-detail-for-child/crud-basic-detail-for-child.component';

import { Component, OnInit, Inject, forwardRef, Injector, ViewChild, Input } from '@angular/core';
import { Validators, FormControl, FormGroup, FormBuilder, AbstractControl, FormControlName } from '@angular/forms';
import { AppComponent } from '../app.component';
import { TranslateService } from '../_services/translate.service';
import { GenericValidator } from '../_helpers/generic-validator';
//import { AutoComplete } from 'primeng/autocomplete';

//import { ILeistungRueckgemeldet } from '../_interfaces/leistung-rueckgemeldet';
import { LeistungRueckgemeldetService } from '../_services/leistung-rueckgemeldet.service';
import { ILeistungskatalogSpediteur } from '../_interfaces/leistungskatalog-spediteur';
import { LeistungskatalogSpediteurService } from '../_services/leistungskatalog-spediteur.service';
import { IBenutzer } from '../_interfaces/benutzer';
import { Subscription } from 'rxjs';
//import { LeistungRueckgemeldetDetailGuard } from './leistung-rueckgemeldet-detail.guard';

//import { LeistungRueckgemeldetDetailComponent_Template } from './leistung-rueckgemeldet-detail.component.include_template';

@Component({
  selector: 'app-auftrags-checkliste-leistungen-detail',
  //template: `${CRUDBasicDetailComponent_Template || ''}${LeistungRueckgemeldetDetailComponent_Template}`,
  templateUrl: './auftrags-checkliste-leistungen-detail.component.html',  
  styleUrls: ['./auftrags-checkliste-leistungen-detail.component.scss'],
  host: { '(window:keydown)': 'hotkeys($event)' }
})
export class LeistungRueckgemeldetDetailComponent extends CRUDBasicDetailForChildComponent implements OnInit {
  @Input() leistungsKatalog: ILeistungskatalogSpediteur[];
  @Input() pruefdatum: Date;

  // CHILD-spezifisch: Konstanten - START
  CRUDItemKurzform: string = "LeistungenRueckgemeldet";
  CRUDPageTitleNeu: string = this.translate.instant("Neue Zusatzleistung", true);
  CRUDPageTitleBearbeiten: string = this.translate.instant("Zusatzleistung bearbeiten", true);
  CRUDItemBezeichnungSingularCapitalized: string = "LeistungRueckgemeldet";
  CRUDItemBezeichnungPluralCapitalized: string = "LeistungenRueckgemeldet";
  CRUDItemBezeichnungSingular: string = "leistungRueckgemeldet";
  CRUDItemBezeichnungPlural: string = "leistungenRueckgemeldet";
  CRUDItemRouteSingular: string = "leistung-rueckgemeldet";
  CRUDItemRoutePlural: string = "leistungen-rueckgemeldet";
  CRUDItemHelpTopic: string = "Leistungen Rückgemeldet";

  debugMode: boolean = false;
  // CHILD-spezifisch: Konstanten - Ende

  // CHILD-spezifisch: zusätzliche Widgets (ausser Standard Inputs, Autocomplete) - START
  leistungsKatalogFiltered: ILeistungskatalogSpediteur[] = null;

  benutzer: IBenutzer = null;
  benutzerSubscription: Subscription = null;
  // CHILD-spezifisch: zusätzliche Widgets (ausser Standard Inputs, Autocomplete) - ENDE

  constructor(
    @Inject( forwardRef(() => AppComponent)) public _app: AppComponent,
    private _injector: Injector,
    private _translate: TranslateService,
    private _crudItemService: LeistungRueckgemeldetService,
    //private _guard: LeistungRueckgemeldetDetailGuard,

    // CHILD-spezifisch: zusätzliche Services - START
    private leistungskatalogSpediteurService: LeistungskatalogSpediteurService
    // CHILD-spezifisch: zusätzliche Services - ENDE
  ) {
    super(_app, _injector);

    this.crudItemService = _crudItemService;
    //this.guard = _guard;

    // CHILD-spezifisch die Validator Messages bestücken - START
    this.validationMessages =
    {
      kopfdatenId: {
        required: this._translate.instant('Kopfdaten Id', true) + ': ' + this._translate.instant('ist erforderlich', true),
      },

      positionsNr: {
        required: this._translate.instant('Positions Nr', true) + ': ' + this._translate.instant('ist erforderlich', true),
      },

      artikelnummer: {
        required: this._translate.instant('Zusatzleistung', true) + ': ' + this._translate.instant('ist erforderlich', true),
      },

      menge: {
        required: this._translate.instant('Menge', true) + ': ' + this._translate.instant('ist erforderlich', true),
      },

      preis: {
        required: this._translate.instant('Preis', true) + ': ' + this._translate.instant('ist erforderlich', true),
      },

      lieferdatum: {
        required: this._translate.instant('Lieferdatum', true) + ': ' + this._translate.instant('ist erforderlich', true),
      },
};
    // CHILD-spezifisch die Validator Messages bestücken - ENDE
    
    this.genericValidator = new GenericValidator(this.validationMessages);

    this.buildForm();
  }

  buildForm() {
    // CHILD-spezifisch die Form aufbauen - START
    this.CRUDForm = this.fb.group({
      kopfdatenId: [0, [Validators.required]],
      auftragspositionenId: [0],
      positionsNr: [0, [Validators.required]],
      artikelnummer: [null, [Validators.required]],
      menge: [0, [Validators.required]],
      preis: [0, [Validators.required]],
      lieferdatum: [null, [Validators.required]],
    });
    // CHILD-spezifisch die Form aufbauen - ENDE
  }

  ngOnInit() {
    this.blockedDocument = true;

    // CHILD-spezifische Zusätze, z.B. Nachladen anderer Entities - START
    // warum auch immer kommt lieferdatum als string -> wandeln in Date
    if(this.CRUDItem.lieferdatum == null || this.CRUDItem.lieferdatum instanceof Date) {
      // alles ok
    }
    else {
      this.CRUDItem.lieferdatum = new Date(this.CRUDItem.lieferdatum);
    }

    this.benutzerSubscription = this.app.benutzerBehaviourSubject.subscribe(benutzer => {
      if(benutzer != null) {
          console.log("AuftragsChecklisteLeistungenDetailComponent() got benutzer:", benutzer);
          this.benutzer = benutzer;

          // ggf. Preis-Prüfungen deaktivieren (Preis wird dann auch im HTML ausgeblendet)
          if(this.benutzer.zusatzleistungPreise != true) {
            this.CRUDForm.controls.preis.setErrors(null);
            this.CRUDForm.controls.preis.clearValidators();
            this.CRUDForm.controls.preis.updateValueAndValidity();
            console.log("AuftragsChecklisteLeistungenDetailComponent() disabled preis");
          }
      }
    });
    // CHILD-spezifische Zusätze, z.B. Nachladen anderer Entities - ENDE

    super.ngOnInit();

    // dataId ist auch 0 wenn automatisch aus auftragsposition erzeugt, aber noch nicht abgespeichert, daher:
    if ((this.CRUDItem.auftragspositionenId == null || this.CRUDItem.auftragspositionenId == 0) && this.CRUDItem.id <= 0 ) {
      this.pageTitle = this.CRUDPageTitleNeu;
    }
    else {
      this.pageTitle = this.CRUDPageTitleBearbeiten;
    }
    if (this.CRUDDisablePageTitleUpdates == false) this.app.setPageTitle(this.pageTitle); //this.app.pageTitle = this.pageTitle;
  }

  ngAfterViewInit(): void {  
    this.leistungsKatalogFiltered = this.leistungsKatalog.filter(f => true); // zunächst mal alle, solange kein SuchBegriff eingegeben wurde

    super.ngAfterViewInit();
  }

  getValuesFromForm() {
    let a = super.getValuesFromForm(); // Standard! do not change!

    // CHILD-spezifische assigns, z.B. spracheId aus strache.Id bestücken - START
    // CHILD-spezifische assigns, z.B. spracheId aus strache.Id bestücken - ENDE

    //console.log("LeistungRueckgemeldetDetailComponent.getValuesFromForm() a:", a);
    return a;
  }

  sendValuesToForm() {
    // CHILD-spezifisch die Form patchen - START
    this.CRUDForm.patchValue({
      kopfdatenId: this.CRUDItem.kopfdatenId,
      auftragspositionenId: this.CRUDItem.auftragspositionenId,
      positionsNr: this.CRUDItem.positionsNr,
      artikelnummer: this.CRUDItem.artikelnummer,
      menge: this.CRUDItem.menge,
      preis: this.CRUDItem.preis,
      lieferdatum: this.CRUDItem.lieferdatum
    });
    // CHILD-spezifisch die Form patchen - ENDE
    //console.log("LeistungRueckgemeldetDetailComponent.sendValuesToForm() CRUDForm:", this.CRUDForm);
    super.sendValuesToForm(); // haben nicht alle DetailComponents - erst ab Ticket 9412 17.07.2019
  }

  posAutoCompleteSearchForDropDown(feld: any, $event) {
    console.log("LeistungRueckgemeldetDetailComponent.posAutoCompleteSearchForDropDown() feld/event:", feld, $event);
    if($event != null && $event.query != null) {
      this.leistungsKatalogFiltered = this.leistungsKatalog.filter(f => f.artikelbezeichnung.toUpperCase().indexOf($event.query.toUpperCase()) > -1);
    }
    else {
      this.leistungsKatalogFiltered = this.leistungsKatalog.filter(f => true); // alle, solange kein SuchBegriff eingegeben wurde
    }
  }

  posAutoCompleteBlur($event) {
    console.log("LeistungRueckgemeldetDetailComponent.posAutoCompleteBlur() event/CRUDForm.value.artikelnummer:", $event, this.CRUDForm.value.artikelnummer);
    // this.CRUDForm.value.artikelnummer ist nicht sofort verfügbar, erst nach timeout, daher:
    this.CRUDForm.patchValue({
      preis: null
    });
    setTimeout(() => {
      this.CRUDForm.patchValue({
        preis: this.CRUDForm.value.artikelnummer.preis
      });
    }, 300);		
  }

  debug(obj) {
    console.log("LeistungRueckgemeldetDetailComponent.debug() leistungsKatalogFiltered:", this.leistungsKatalogFiltered);
    super.debug(obj);
  }
}
